import React from 'react';
import { Tooltip } from 'antd';
import { TAG_TYPE } from 'types/client';
import StarIcon from 'shared/assets/images/star-icon.svg';
import BookmarkIcon from 'shared/assets/images/bookmark-icon.svg';
import DollarIcon from 'shared/assets/images/dollar-icon.svg';
import './style.less';

export const TAGS: Record<
  TAG_TYPE,
  {
    icon: React.ReactNode;
    color: string;
    title: string;
  }
> = {
  [TAG_TYPE.NEW_PLAN]: {
    icon: <StarIcon className="star" height={8} />,
    color: 'linear-gradient(38.12deg, #E777091A 4.57%, #D99E001A 102.26%)',
    title: 'New customer',
  },
  [TAG_TYPE.TRIAL_PLAN]: {
    icon: <BookmarkIcon height={8} />,
    color: 'linear-gradient(38.12deg, #5454D41A 4.57%, #8585FF1A 102.26%)',
    title: 'Trial customer',
  },
  [TAG_TYPE.PAID_PLAN]: {
    icon: <DollarIcon height={9} />,
    color: 'linear-gradient(226.44deg, #71F4A51A 0%, #00BB4B1A 100%)',
    title: 'Paying customer',
  },
};

function isValidTag(tag: unknown): tag is TAG_TYPE {
  return !!tag && typeof tag === 'string' && tag in TAGS;
}

interface CustomTagProps {
  tag: unknown;
}

export const CustomTag: React.FC<CustomTagProps> = ({ tag }) => {
  if (!isValidTag(tag)) return null;

  return (
    <Tooltip title={TAGS[tag].title}>
      <div className="CustomTag" style={{ background: TAGS[tag].color }}>
        {TAGS[tag].icon}
      </div>
    </Tooltip>
  );
};
